import React, { useContext } from 'react';
import styled from 'styled-components';

import DeadlineModalContext from '../../../modules/contexts/DeadlineModalContext';

import { babyface } from '../../../lib/image/CDNUrl';
import { Flex } from '../atom/Layout';
import { Button } from '../atom/Button';
import { ModalBackground } from './Modal';
import { breakpoint } from '../../../lib/style/ThemeStyle';

const DeliveryImg = babyface.concat('/delivery_260921.png');

const DeliveryModal = () => {
  const {
    state: { showModal },
    actions: { dayCloseModal, closeModal },
  } = useContext(DeadlineModalContext);

  return (
    showModal && (
      <ModalBackground>
        <Flex column alignItems="stretch">
          <ModalImg src={DeliveryImg} alt="❌" />
          <Flex alignItems="flex-start" justifyContent="flex-start">
            <ModalButton backgroundColor="#f5dee1" onClick={dayCloseModal}>
              오늘 하루 보지 않기
            </ModalButton>
            <ModalButton backgroundColor="#ecc2d1" onClick={closeModal}>
              닫기
            </ModalButton>
          </Flex>
        </Flex>
      </ModalBackground>
    )
  );
};

export default React.memo(DeliveryModal);

const ModalImg = styled.img`
  width: 400px;
  object-fit: cover;
  @media (max-width: ${breakpoint}px) {
    width: 100%;
    max-width: 320px;
    height: 100%;
    object-fit: contain;
  }
`;

const ModalButton = styled(Button)`
  height: 2.5rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.color.darkest};
  border-radius: 0;
  background: ${(props) => props.backgroundColor};
  font-weight: 400;
`;
